import { MenuItem, Typography } from '@mui/material'

import { SELECT_BOX_TEST_IDS } from '../SelectBox.constants'

type NoOptionsMessageProps = {
  message: string
  show: boolean
}

export const NoOptionsMessage = ({ message, show }: NoOptionsMessageProps) => {
  if (!show) return null

  return (
    <MenuItem
      disabled
      data-testid={SELECT_BOX_TEST_IDS.noOptions}
      sx={{
        opacity: '1 !important',
        color: 'text.primary',
        '&.Mui-disabled': {
          color: 'text.primary',
          opacity: 1
        }
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </MenuItem>
  )
}
